import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "items-center tracker-wide text-lg font-semibold py-3" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Account members ")
const _hoisted_6 = {
  key: 0,
  class: "ml-1 font-medium text-gray-500"
}
const _hoisted_7 = { class: "flex flex-col card-main mt-8 mb-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccontMembersTable = _resolveComponent("AccontMembersTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _hoisted_5,
          (_ctx.analytics)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_6, " (" + _toDisplayString(_ctx.analytics) + ")", 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_AccontMembersTable)
    ])
  ]))
}